export default class SurveyTranslate {
  id: number;
  language: {id: number, code: string};
  title: string;
  enunciated: string;
  final_msg_thanks: string;
  final_msg_footer: string;
  header_msg: any = null;
}
